export const DOCUMENT_TRAINING_ROUTE = "/genai-knowledge-base";
export const DOCUMENT_TRAINING_DETAIL_ROUTE = "/genai-knowledge-base/:documentCode";
